import { createAsyncThunk } from '@reduxjs/toolkit';
import { postTransferItemsBetweenPrivateAndPublicProjectBank } from 'scenes/ProjectBank/services/postTransferItemsBetweenPrivateAndPublicProjectBank.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const transferItemsBetweenPrivateAndPublicProjectBank = createAsyncThunk(
  'projectBank/transferItemsBetweenPrivateAndPublicProjectBank',
  async (
    {
      itemIdsToTransfer,
      targetParentFolderId,
      sourceProjectBankPrivacy,
      targetProjectBankPrivacy,
      transferMethod,
    },
    { getState }
  ) => {
    const state = getState();

    const projectId = selectSelectedProjectId(state);

    const response = await postTransferItemsBetweenPrivateAndPublicProjectBank(
      {
        itemIdsToTransfer,
        projectId,
        targetParentFolderId,
        sourceProjectBankPrivacy,
        targetProjectBankPrivacy,
        transferMethod,
      },
      projectId
    );

    return response;
  }
);
